module.exports = __webpack_public_path__ + "img/payment-guaranteedPayment.a0c50d7.svg";